import React from 'react'

const Modal = ({ content, onClose }) => {
  return (
    <div className="modal" style={{zIndex:10}}>
      <div className="modal-content">
        {content}
        <button onClick={onClose}>Close Modal</button>
      </div>
    </div>
  );
};

export default Modal